<template>
  <div
    v-if="section.items.length"
    class="section"
    :key="section.name"
    :id="slug"
  >
    <h3
      v-intersect="{ handler: onIntersect, options: intersectOptions }"
      :class="['text-h4 section-title mb-3 pb-1 font-weight-bold mx-n1 px-1']"
      >{{ section.name }}</h3
    >
    <div
      v-if="section.description"
      class="section-desc proxima--font mb-4 font-weight-bold"
      >{{ section.description }}</div
    >
    <MenuItem
      v-for="(item, i) of section.items"
      :key="item.id"
      :item-id="item.id"
      :list-position="i"
    />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import MenuItem from '@/components/MenuItem'
import slugMe from '@/utils/slugMe'

export default {
  name: 'MenuSection',
  components: { MenuItem },
  props: {
    section: {
      type: Object,
      require: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isDropdownVisible: false,
      intersectOptions: {
        // threshold: [0.25],
      },
    }
  },
  computed: {
    ...mapFields('cart', ['visibleMenuSections', 'isScrollObservationAllowed']),
    slug() {
      return slugMe(this.section.name)
    }, // slug
  },
  methods: {
    onIntersect(entries) {
      if (!this.isScrollObservationAllowed) return

      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.visibleMenuSections = entries[0].isIntersecting
        ? [this.index, ...this.visibleMenuSections]
        : this.visibleMenuSections.filter((index) => index !== this.index)
    },
  },
}
</script>

<style lang="scss">
.section-title {
  position: sticky;
  top: 48px;
  background: white;
  z-index: 3;
}
.section-desc {
  white-space: pre-wrap;
  font-size: 1.15rem;
  color: lighten(black, 20);
}
</style>
